import React from 'react';
import { Link } from 'react-router-dom';
import { FaCalendarAlt, FaUser, FaArrowRight, FaTag } from 'react-icons/fa';
import './Blog.css';

const Blog = () => {
  const featuredPost = {
    id: 1,
    title: '10 Essential Tips to Improve Your Badminton Smash',
    excerpt: 'Master the most powerful shot in badminton with our comprehensive guide. Learn proper technique, timing, and practice drills that will take your smash to the next level.',
    image: 'https://images.unsplash.com/photo-1626224583764-f87db24ac4ea?w=800',
    author: 'Coach David Wong',
    date: 'January 5, 2025',
    category: 'Training Tips',
    readTime: '8 min read'
  };

  const posts = [
    {
      id: 2,
      title: 'Choosing the Right Badminton Racket: A Complete Guide',
      excerpt: 'Find the perfect racket for your playing style with our expert recommendations and buying guide.',
      image: 'img/Choosing the Right Badminton Racket.jpg',
      author: 'Lisa Wang',
      date: 'January 2, 2025',
      category: 'Equipment',
      readTime: '6 min read'
    },
    {
      id: 3,
      title: 'Footwork Fundamentals: The Foundation of Great Badminton',
      excerpt: 'Good footwork is the secret to reaching every shot. Learn essential movement patterns and exercises.',
      image: 'img/Footwork Fundamentals.jpg',
      author: 'Coach Sarah Chen',
      date: 'December 28, 2024',
      category: 'Training Tips',
      readTime: '7 min read'
    },
    {
      id: 4,
      title: 'Net Nest Winter Championship 2025 Recap',
      excerpt: 'Highlights from our biggest tournament of the season featuring incredible matches and rising stars.',
      image: 'img/Net Nest Winter.jpg',
      author: 'Kevin Martinez',
      date: 'December 20, 2024',
      category: 'Events',
      readTime: '5 min read'
    },
    {
      id: 5,
      title: 'The Benefits of Badminton for Mental Health',
      excerpt: 'Discover how playing badminton can reduce stress, improve focus, and boost your overall wellbeing.',
      image: 'img/The Benefits of Badminton for Mental Health.jpg',
      author: 'Dr. Amanda Taylor',
      date: 'December 15, 2024',
      category: 'Health & Fitness',
      readTime: '6 min read'
    },
    {
      id: 6,
      title: 'Junior Academy Success Stories',
      excerpt: 'Meet the young talents from our academy who are making waves in competitive badminton.',
      image: 'img/Junior Academy Success Stories.jpg',
      author: 'Coach Jennifer Liu',
      date: 'December 10, 2024',
      category: 'Community',
      readTime: '5 min read'
    },
    {
      id: 7,
      title: 'Common Badminton Injuries and How to Prevent Them',
      excerpt: 'Stay injury-free with proper warm-up routines, technique tips, and recovery practices.',
      image: 'img/Common Badminton Injuries and How to Prevent Them.jpg',
      author: 'Michael Rodriguez',
      date: 'December 5, 2024',
      category: 'Health & Fitness',
      readTime: '8 min read'
    }
  ];

  const categories = [
    { name: 'All Posts', count: 25 },
    { name: 'Training Tips', count: 10 },
    { name: 'Equipment', count: 5 },
    { name: 'Events', count: 4 },
    { name: 'Health & Fitness', count: 4 },
    { name: 'Community', count: 2 }
  ];

  const popularTags = [
    'Technique', 'Beginner', 'Advanced', 'Rackets', 'Fitness',
    'Tournaments', 'Coaching', 'Singles', 'Doubles', 'Footwork'
  ];

  return (
    <div className="blog-page">
      {/* Page Header */}
      <section className="page-header">
        <div className="page-header-overlay"></div>
        <div className="container">
          <div className="page-header-content">
            <span className="page-badge">Our Blog</span>
            <h1>Latest News & Tips</h1>
            <p>Insights, stories, and tips from the Net Nest community</p>
            <nav className="breadcrumb">
              <Link to="/">Home</Link>
              <span>/</span>
              <span>Blog</span>
            </nav>
          </div>
        </div>
      </section>

      {/* Featured Post */}
      <section className="featured-post section">
        <div className="container">
          <Link to={`/blog/${featuredPost.id}`} className="featured-card">
            <div className="featured-image">
              <img src={featuredPost.image} alt={featuredPost.title} />
              <span className="featured-badge">Featured</span>
            </div>
            <div className="featured-content">
              <span className="post-category">{featuredPost.category}</span>
              <h2>{featuredPost.title}</h2>
              <p>{featuredPost.excerpt}</p>
              <div className="post-meta">
                <span><FaUser /> {featuredPost.author}</span>
                <span><FaCalendarAlt /> {featuredPost.date}</span>
                <span>{featuredPost.readTime}</span>
              </div>
              <span className="read-more">
                Read Article <FaArrowRight />
              </span>
            </div>
          </Link>
        </div>
      </section>

      {/* Blog Content */}
      <section className="blog-content section">
        <div className="container">
          <div className="blog-grid">
            {/* Posts */}
            <div className="blog-posts">
              <h3 className="posts-title">Recent Articles</h3>
              <div className="posts-grid">
                {posts.map((post) => (
                  <Link to={`/blog/${post.id}`} className="post-card" key={post.id}>
                    <div className="post-image">
                      <img src={post.image} alt={post.title} />
                    </div>
                    <div className="post-content">
                      <span className="post-category">{post.category}</span>
                      <h4>{post.title}</h4>
                      <p>{post.excerpt}</p>
                      <div className="post-meta">
                        <span><FaCalendarAlt /> {post.date}</span>
                        <span>{post.readTime}</span>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            </div>

            {/* Sidebar */}
            <aside className="blog-sidebar">
              {/* Popular Tags */}
              <div className="sidebar-widget">
                <h4>Popular Tags</h4>
                <div className="tags-cloud">
                  {popularTags.map((tag, index) => (
                    <span className="tag" key={index}>
                      <FaTag /> {tag}
                    </span>
                  ))}
                </div>
              </div>
            </aside>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Blog;
